module.exports = __webpack_public_path__ + "img/Sezione Scritti e Discorsi ipotesi B.29b5e3d2.jpeg";